








































































import { LoadingStatusType, QRPaymentType, TransactionType } from "@/enums/enums";
import { GetBankAccountType, GetBankReferenceHelper } from "@/helper/bankReferenceListHelper";
import { MerchantModel } from "@/model/merchant/merchantModel";
import { DataQRPaymentModel, QRCodePaymentModel } from "@/model/payment/paymentModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import QRCode from "qrcode";

const StorePayment = namespace("Payment");
const StoreMerchant = namespace("Merchant");

@Component
export default class ModalMakePayment extends Vue {
  @Prop({ default: 0 }) transactionId!: number;
  @Prop({ default: 0 }) transactionType!: TransactionType;

  private showModal = true;
  private blobUrl = process.env.VUE_APP_PeakBlobStorage;
  private qrPaymentTypeId = QRPaymentType.None;
  private isSettingBank = false;
  private imgUrl = "";
  private remark = "";
  private bankName = "";
  private bankNumber = "";
  private bankLogo = "";
  private bankHeader = "";

  @StorePayment.Getter
  private getTransactionRemainPaymentModel!: any;
  @StoreMerchant.Getter
  private getMerchantQRPaymentSettingLoadingStatus!: LoadingStatusType;
  @StoreMerchant.Getter
  private getMerchantQRPaymentModel!: any;
  @StorePayment.Getter
  private getSCBQRCodePaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getSCBQRCodePaymentModel!: DataQRPaymentModel;
  @StorePayment.Getter
  private getBayQRCodePaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getBayQRCodePaymentModel!: DataQRPaymentModel;
  @StorePayment.Getter
  private getBblQRCodePaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getBblQRCodePaymentModel!: DataQRPaymentModel;
  @StoreMerchant.Getter
  private getMerchantDetail!: MerchantModel;

  @StoreMerchant.Action
  private DoGetQRPaymentSetting!: () => void;
  @StorePayment.Action
  private DoGetSCBQRCodePayment!: (input: QRCodePaymentModel) => void;
  @StorePayment.Action
  private DoGetBayQRCodePayment!: (input: QRCodePaymentModel) => void;
  @StorePayment.Action
  private DoGetBblQRCodePayment!: (input: QRCodePaymentModel) => void;

  get isQRPaymentTypeUpload() {
    return this.qrPaymentTypeId === QRPaymentType.Bank;
  }

  get isQRPaymentTypeBank() {
    return (
      this.qrPaymentTypeId === QRPaymentType.SCB ||
      this.qrPaymentTypeId === QRPaymentType.Bay ||
      this.qrPaymentTypeId === QRPaymentType.Bbl
    );
  }

  created() {
    this.GetQRPaymentSetting();
  }

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  @Watch("getMerchantQRPaymentSettingLoadingStatus")
  getMerchantQRPaymentSettingLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.qrPaymentTypeId = this.getMerchantQRPaymentModel.qrPaymentTypeId;
      switch (this.getMerchantQRPaymentModel.qrPaymentTypeId) {
        case QRPaymentType.SCB:
          this.GetSCBQRCodePayment();
          break;
        case QRPaymentType.Bay:
          this.GetBayQRCodePayment();
          break;
        case QRPaymentType.Bbl:
          this.GetBblQRCodePayment();
          break;
        default:
          this.SetQRPaymentSettingData();
          break;
      }
    }
  }

  @Watch("getSCBQRCodePaymentLoadingStatus")
  getSCBQRCodePaymentStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.SetSCBQRPaymentSettingData();
    }
  }

  @Watch("getBayQRCodePaymentLoadingStatus")
  getBayQRCodePaymentStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.SetBayQRPaymentSettingData();
    }
  }

  @Watch("getBblQRCodePaymentLoadingStatus")
  getBblQRCodePaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.SetBblQRPaymentSettingData();
    }
  }

  public SetQRPaymentSettingData() {
    this.imgUrl = this.blobUrl.UrlCombine(`peakengine${this.getMerchantQRPaymentModel.qrPaymentCodeModel.imgUrl}`);
    this.remark = this.getMerchantQRPaymentModel.qrPaymentCodeModel.remark
      ? this.getMerchantQRPaymentModel.qrPaymentCodeModel.remark
      : "-";
    this.bankName = GetBankReferenceHelper(this.getMerchantQRPaymentModel.qrPaymentCodeModel.bankReferenceId).name;
    this.bankLogo = GetBankReferenceHelper(this.getMerchantQRPaymentModel.qrPaymentCodeModel.bankReferenceId).imgUrl;
    this.bankNumber = this.getMerchantQRPaymentModel.qrPaymentCodeModel.bankNumber;
  }

  public SetSCBQRPaymentSettingData() {
    const settingSCBQRPaymentCodeModel =
      this.getMerchantQRPaymentModel.scbQRPaymentCodeModel.settingSCBQRPaymentCodeModel;
    this.imgUrl = `data:image/png;base64, ${this.getSCBQRCodePaymentModel.qrImage}`;
    this.bankName = GetBankReferenceHelper(settingSCBQRPaymentCodeModel.bankReferenceTypeId).name;
    this.bankLogo = GetBankReferenceHelper(settingSCBQRPaymentCodeModel.bankReferenceTypeId).imgUrl;
    this.bankNumber = settingSCBQRPaymentCodeModel.bankNumber;
    this.bankHeader = "Content/Image/BankLogo/SCB_Header.png";
    this.isSettingBank = settingSCBQRPaymentCodeModel.bankAccountId > 0;
  }

  public SetBayQRPaymentSettingData() {
    QRCode.toDataURL(this.getBayQRCodePaymentModel.qrRawData)
      .then((url: any) => {
        this.imgUrl = url;
      })
      .catch((err: any) => {});

    const settingBayQRPaymentCodeModel =
      this.getMerchantQRPaymentModel.bayQRPaymentCodeModel.settingBayQRPaymentCodeModel;
    this.bankName = GetBankReferenceHelper(settingBayQRPaymentCodeModel.bankReferenceTypeId).name;
    this.bankLogo = GetBankReferenceHelper(settingBayQRPaymentCodeModel.bankReferenceTypeId).imgUrl;
    this.bankNumber = settingBayQRPaymentCodeModel.bankNumber;
    this.bankHeader = "Content/Image/BankLogo/Bay_Header.png";
    this.isSettingBank = settingBayQRPaymentCodeModel.bankAccountId > 0;
  }

  public SetBblQRPaymentSettingData() {
    QRCode.toDataURL(this.getBblQRCodePaymentModel.qrRawData)
      .then((url: any) => {
        this.imgUrl = url;
      })
      .catch((err: any) => {});

    const settingBblQRPaymentCodeModel =
      this.getMerchantQRPaymentModel.bblQRPaymentCodeModel.settingBblQRPaymentCodeModel;
    this.bankName = GetBankReferenceHelper(settingBblQRPaymentCodeModel.bankReferenceTypeId).name;
    this.bankLogo = GetBankReferenceHelper(settingBblQRPaymentCodeModel.bankReferenceTypeId).imgUrl;
    this.bankNumber = settingBblQRPaymentCodeModel.bankNumber;
    this.bankHeader = "Content/Image/BankLogo/Bbl_Header.png";
    this.isSettingBank = settingBblQRPaymentCodeModel.bankAccountId > 0;
  }

  public DownLoadQrCode() {
    window.open(this.imgUrl);
  }

  public HideModal() {
    this.$emit("update:showModal", false);
    this.$emit("checkPayment");
  }

  public GetQRPaymentSetting() {
    this.DoGetQRPaymentSetting();
  }

  public GetSCBQRCodePayment() {
    const input: QRCodePaymentModel = {
      transactionId: this.transactionId,
      transactionTypeId: this.transactionType,
      language: this.$i18n.locale,
    };
    this.DoGetSCBQRCodePayment(input);
  }

  public GetBayQRCodePayment() {
    const input: QRCodePaymentModel = {
      transactionId: this.transactionId,
      transactionTypeId: this.transactionType,
      language: this.$i18n.locale,
    };
    this.DoGetBayQRCodePayment(input);
  }

  public GetBblQRCodePayment() {
    const input: QRCodePaymentModel = {
      transactionId: this.transactionId,
      transactionTypeId: this.transactionType,
      language: this.$i18n.locale,
    };
    this.DoGetBblQRCodePayment(input);
  }

  public GetPaymentMethodType() {
    if (this.getMerchantQRPaymentModel.qrPaymentTypeId === QRPaymentType.SCB) {
      return GetBankAccountType(
        this.getMerchantQRPaymentModel.scbQRPaymentCodeModel.settingSCBQRPaymentCodeModel.bankTypeId
      );
    } else {
      return "";
    }
  }

  public RedirectToConfigScb() {
    window.open(
      `${
        process.env.VUE_APP_PeakAccount
      }setting/connectApiQrPaymentDetail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eapi=${QRPaymentType.SCB.PeakEncryption()}&isSetting=1`
    );
  }
}
